module.exports = __webpack_public_path__ + "img/16d001-18.16f38cf4.jpg";